import swal2 from 'sweetalert2';

const CONFIRMATION_TEXT_STYLE = 'font-size: 1rem; line-height: 1.5;';

export const inviteToFillNotionFields = (message) =>
    swal2.fire({
        title: 'O Parecer ainda não tem resumo e estudo de caso',
        html: `<div style="${CONFIRMATION_TEXT_STYLE}">${message}</div>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Preencher agora',
        cancelButtonText: 'Voltar',
    }).then(result => !!result.isConfirmed);
